"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definitionNeedsTheseExternals = exports.getSchemas = exports.concatIfDef = exports.getUserName = exports.splitCamelCase = exports.removeSpecialCharacters = exports.nowString = void 0;
const tslib_1 = require("tslib");
function nowString() {
    const now = new Date();
    const MMM = now
        .toLocaleString('default', { month: 'long' })
        .slice(0, 3)
        .toUpperCase();
    const DD = now.getDate();
    const timeString = now.toTimeString().substring(0, 5).replace(':', '-');
    return `${MMM}${DD}_${timeString}`;
}
exports.nowString = nowString;
function removeSpecialCharacters(input) {
    return input.replace(/[^0-9a-zA-Z_ ]/g, '');
}
exports.removeSpecialCharacters = removeSpecialCharacters;
function splitCamelCase(input) {
    let output = '';
    let previousCharIsLowercase = false;
    for (const char of input) {
        const charIsUppercase = char === char.toUpperCase();
        if (charIsUppercase && previousCharIsLowercase) {
            output += ' ';
        }
        previousCharIsLowercase = !charIsUppercase;
        output += char;
    }
    return output;
}
exports.splitCamelCase = splitCamelCase;
const DEFAULT_NAME = 'PATIENT NAME NOT FOUND';
function getUserName(user) {
    if (!user)
        return DEFAULT_NAME;
    const results = `${concatIfDef(user === null || user === void 0 ? void 0 : user.fname, ' ')}${user === null || user === void 0 ? void 0 : user.lname}`;
    return results || DEFAULT_NAME;
}
exports.getUserName = getUserName;
function concatIfDef(value, toConcat) {
    return value != undefined ? value.toString().concat(toConcat) : '';
}
exports.concatIfDef = concatIfDef;
function getSchemas(db, definition) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const workflowSchemaIds = [];
        const formSchemaIds = [];
        for (const section of definition.sections) {
            if (section.type === 'action' ||
                section.type === 'ongoing' ||
                section.type === 'workflow') {
                const id = section.workflow.toString();
                !workflowSchemaIds.includes(id) && workflowSchemaIds.push(id);
            }
            else if (section.type === 'form') {
                const id = section.form.toString();
                !formSchemaIds.includes(id) && formSchemaIds.push(id);
            }
        }
        const schemas = {};
        for (const workflowSchemaId of workflowSchemaIds) {
            const workflowSchema = yield db.get.workflow.schema.byId(workflowSchemaId);
            if (!workflowSchema)
                throw new Error(`Could not find schema with ID ${workflowSchemaId}`);
            schemas[workflowSchemaId.toString()] = workflowSchema;
            if (workflowSchema.externals &&
                workflowSchema.schema.externals &&
                definitionNeedsTheseExternals(definition, workflowSchemaId)) {
                for (const [externalId, type] of Object.entries(workflowSchema.schema.externals)) {
                    if (type === 'form') {
                        formSchemaIds.push(workflowSchema.externals[externalId]);
                    }
                }
            }
        }
        for (const formSchemaId of formSchemaIds) {
            const formSchema = yield db.get.form.schema.byId(formSchemaId);
            if (!formSchema)
                throw new Error(`Could not find schema with ID ${formSchemaId}`);
            schemas[formSchemaId.toString()] = formSchema;
        }
        return schemas;
    });
}
exports.getSchemas = getSchemas;
function definitionNeedsTheseExternals(definition, workflowSchemaId) {
    for (const section of definition.sections) {
        if (section.type === 'workflow' &&
            section.workflow.toString() === workflowSchemaId.toString() &&
            section.externals) {
            return true;
        }
    }
    return false;
}
exports.definitionNeedsTheseExternals = definitionNeedsTheseExternals;
//# sourceMappingURL=utils.js.map